import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { getHTML } from '../../../services/commonFunction';

function ServicesCard({data}) {
  const contentData = useSelector(state => state.Data.contentData);
  const langPrefix = useSelector(state => state.Data.langPrefix);
  return (
    <Link to={`/${langPrefix}service/${data?.path}`} className="shadow block shadow-hover bg-white relative h-[387px] max-[1700px]:h-[300px] max-[1400px]:h-[247px] border border-[1px] mb-[20px] border-white cursor-pointer group overflow-hidden">
        <img className="w-full h-full group-hover:scale-[1.1] transition-all duration-500" src={data?.image_full_url} />
        <div className="absolute bottom-0 left-0 w-full h-[50px] bg-black/60 flex flex-col transition-all duration-500 group-hover:h-full flex items-center justify-center">
            <h2 className="text-white text-[24px]  font-[600] max-[800px]:text-[20px]">{data?.translate?.title}</h2>
            <p className='hidden group-hover:block p-[10px] text-center text-white text-[16px] font-[300]'>{getHTML(data?.translate?.description)?.replaceAll("&nbsp;","")?.replaceAll("&nbsp","")?.substring(0,200)}...</p>
            <a  className='hidden group-hover:block p-[4px_20px] border border-white text-center text-white text-[16px] font-[400] rounded-full hover:border-[--dark-green] hover:bg-[--dark-green]' href='#'>{contentData?.read_more}</a>
        </div>
    </Link>

  )
}

export default ServicesCard